import { useEffect } from 'react';
import { createStore } from 'redux';

/**
  * Emitter
  *
  * This is a way to communicate between jQueryland and Reactland.
  * In hindsight, if jQuery needs to affect state in React, we
  * should have lifted the state to Redux but :shrug:
  *
  * useListener: Hook to listen to events in React
  *
  * listenOn: Hook to listen to events in jQuery
  */
const eventReducer = (_state, action = {}) => action;

export const emitter = createStore(eventReducer);

function shouldExecuteCallback(event, callback) {
  const lastEvent = emitter.getState();

  if (lastEvent && lastEvent.type === event) {
    callback(lastEvent.data);
  }
}

export function useListener(event, callback) {
  useEffect(() => {
    const unsubscribe = emitter.subscribe(() => shouldExecuteCallback(event, callback));

    return () => unsubscribe();
  }, [callback]);
}

export function listenOn(event, callback) {
  return emitter.subscribe(() => shouldExecuteCallback(event, callback));
}

const { dispatch } = emitter;

export { dispatch };
